import { GeneralOverview } from "asset-analysis/lib/@types/analysis/utils/general";
import { store } from "../services/asset-analysis-overview";

export default function useAssetAnalysisOverview() {
  function storeReport(
    data: GeneralOverview,
    encodedId: string
  ): Promise<boolean> {
    return store(data, encodedId);
  }

  return { storeReport };
}
